'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const ContextComponent = require('../../../global/components/ContextComponent');
const SanitizeHtml = require('../../../global/components/SanitizeHtml');
const inViewport = require('in-viewport');
const scrollIntoView = require('scroll-into-view');

const {trackDescriptionExpand, trackDescriptionCollapse} = require('../../actions/pdpTrackingActions');
const PdpActions = require('../../actions/PdpActions');

// Need some extra padding below the description when it is expanded or else the "READ LESS" text cuts off the description.
const EXPANDED_PADDING = 6;

class ExpandableContent extends ContextComponent {

    constructor(props) {
        super(props);

        this.state = {
            isExpanded: props.expanded,
            hasReadMore: false
        };

        this._toggleReadMore = this._toggleReadMore.bind(this);
        this._setExpanded = this._setExpanded.bind(this);
    }

    componentDidMount() {
        this._setReadMore();
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.isExpanded) {
            this._getDescriptionHeight();
        }
    }

    _getDescriptionHeight() {
        this.height = this._description.offsetHeight;
    }

    _setReadMore() {
        this._getDescriptionHeight();

        // Check if the actual height of the description is greater than the collapseHeight.
        // If it is we want to show the "CONTINUE READING" text link.
        if (this.height > this.props.collapseHeight) {
            this.setState({ hasReadMore: true });
        }
    }

    _toggleReadMore() {
        const { scrollDuration } = this.props;
        const { isExpanded } = this.state;
        const self = this;

        // Check if the header is in view and scroll to it if needed.
        // The content will be collapsed after the scroll is completed
        if (!inViewport(this._header)) {
            scrollIntoView(this._header, {time: scrollDuration}, function () {
                self._setExpanded(isExpanded);
            });
        } else {
            this._setExpanded(isExpanded);
        }

        if (this.props.tracking) {
            this._tracking();
        }
    }

    _tracking() {
        const action = this.state.isExpanded ? trackDescriptionCollapse : trackDescriptionExpand;

        this.context.executeAction(action);
    }

    _setExpanded(isExpanded) {
        this.setState({ isExpanded: !isExpanded });
        this.context.executeAction(PdpActions.setHeroExpanded, { heroExpanded: isExpanded });
        this._changeSizeListener();
    }

    // Keep track of the state of the expand/collapse transition so other components on the page cam react to the change
    // in size.
    _changeSizeListener() {
        const handleTransitionend = () => {
            this.context.executeAction(PdpActions.setHeroChangingSize, { heroChangingSize: false });
            this._descriptionWrapper.removeEventListener('transitionend', handleTransitionend);
        };

        this._descriptionWrapper.addEventListener('transitionend', handleTransitionend);
    }

    render() {
        const { description, title, name, image: imagePath, collapseHeight, tnType, isPrintHero } = this.props;
        const { isExpanded, hasReadMore } = this.state;
        const hasImage = !!imagePath;
        const classes = classnames('pdp-hero-about-wrapper', { expanded: isExpanded }, { 'pdp-hero-about-has-image': hasImage });
        const readMoreText = isExpanded ? `read less -` : `continue reading +`;
        const descriptionHeight = { height: isExpanded ? this.height + EXPANDED_PADDING : collapseHeight };
        const wrapperDataTags = isPrintHero ? `print-pdp-${tnType}-description-wrapper` : `pdp-${tnType}-description-wrapper`;
        const descriptionDataTags = isPrintHero ? `print-pdp-${tnType}-description` : `pdp-${tnType}-description`;
        const image = (
            <div className="pdp-hero-image-overlay">
                <img src={imagePath} className="pdp-hero-image-overlay-content" />
            </div>
        );

        return (
            <div className={classes}>
                {hasImage ? image : null}
                <div className="pdp-hero-body-about-wrapper">
                    <h2 className="pdp-hero-about header-primary-large pdp-secondary-header"
                        ref={(header => { this._header = header; })}
                    >
                        {title} {name}
                    </h2>

                    <div ref={(descriptionWrapper => { this._descriptionWrapper = descriptionWrapper; })} className="pdp-hero-description-wrapper" data-tn={wrapperDataTags} style={descriptionHeight}>
                        <div className="pdp-hero-description" ref={(descriptionContent => { this._description = descriptionContent; })} data-tn={descriptionDataTags}>
                            <SanitizeHtml content={description} />
                        </div>
                    </div>
                    {hasReadMore ? <a href="#0" className="pdp-hero-read-more" data-tn={`pdp-${tnType}-read-more`} onClick={this._toggleReadMore}>{readMoreText}</a> : null}
                </div>
            </div>
        );
    }
}

ExpandableContent.propTypes = {
    description: PropTypes.string.isRequired,
    title: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string,

    tracking: PropTypes.bool,
    expanded: PropTypes.bool,

    collapseHeight: PropTypes.number,
    tnType: PropTypes.string,
    scrollDuration: PropTypes.number
};

ExpandableContent.defaultProps = {
    tracking: true,
    expanded: false,

    collapseHeight: 144,
    tnType: 'item',
    scrollDuration: 1000
};

module.exports = ExpandableContent;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ExpandableContent/ExpandableContent.jsx